import styled, { createGlobalStyle } from "styled-components";

export const FullCalendarStyles = styled.div`
  overflow: scroll;
  height: 100vh;
`;

export const FullCalendarGlobalStyles = createGlobalStyle`
  .fc-toolbar.fc-header-toolbar{
    position: sticky;
    top: 0;
    background: var(--backgroundColorCard);
    border-bottom: 1px solid var(--borderColor);
    z-index: 50;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
    
  }
.fc .fc-timegrid-slot-lane {
position: relative;
background:transparent;
}

.fc .fc-timegrid-slot-lane::after {
content: "";
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
pointer-events: none;
z-index: 1;

background-image: linear-gradient(to right,
var(--fc-border-color) 0 1px,
transparent 1px calc(100% / var(--fc-resource-count))
);
background-size: calc(100% / var(--fc-resource-count)) 100%;
background-repeat: repeat-x;
}
.fc .fc-timegrid-slot-lane > * {
position:relative;
z-index:2;
}
  .fc td {
    background: var(--backgroundColorCard) !important;
  }

  .fc .fc-scroller {
    max-height: 100%;
    overflow-y: auto;
  }

   @media screen and (max-width: 600px) { 
    .fc .fc-scroller {
    max-height: auto;
    overflow-y: auto;
  }
   }

  .fc .fc-event { border-radius: 6px; padding: 4px 6px; font-weight: 500; }
  /* restore older color palette for events and toolbar */
  .fc .fc-event {
    background-color: var(--lightBlue);
    border-left: 4px solid var(--primarySystem300);
    color: var(--textColor);
    padding: 6px 8px;
    font-weight: 600;
    box-shadow: none;
  }

  /* Prevent event content from overflowing the card. Use hidden overflow on the container
     tooltip is still rendered in a portal (document.body) and can overflow independently. */
  .fc .fc-event,
  .fc .fc-timegrid-event,
  .fc .fc-timegrid-event-harness,
  .fc .fc-event-main,
  .fc .fc-event-main-frame,
  .fc .fc-event-head,
  .fc .fc-event-tail {
    overflow: hidden !important;
    white-space: normal !important;
    box-sizing: border-box;
  }

  /* Event element sizing: keep min-height for touch targets, allow auto height but clip overflow. */
  .fc .fc-event { display: block; min-height: 48px; height: auto !important; max-height: none !important; z-index: 2; overflow: hidden !important; }
  .fc .fc-timegrid-event { height: auto !important; max-height: none !important; }
  .fc .fc-event-main-frame { overflow: hidden !important; z-index: 3; }

  .fc .fc-event .break-words {
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden !important;
    text-overflow: ellipsis;
    word-break: break-word !important;
  }

  .fc .fc-event-title { font-size: 0.95rem; }
  .fc .fc-event-time { font-size: 0.85rem; color: var(--textLight); }

  .fc-toolbar.fc-header-toolbar{
    background: var(--backgroundColorCard);
    color: var(--textColor);
  }

  /* Reduce header font sizes and buttons in the calendar header */
  .fc-toolbar.fc-header-toolbar .fc-button,
  .fc-toolbar.fc-header-toolbar .fc-toolbar-title {
    font-size: 0.85rem;
  }

  @media screen and (max-width: 768px) {
    .fc-toolbar.fc-header-toolbar,
    .fc-toolbar.fc-header-toolbar .fc-button,
    .fc-toolbar.fc-header-toolbar .fc-toolbar-title {
      font-size: 0.7rem;
    }
    .fc-toolbar.fc-header-toolbar {
      padding: 4px;
      gap: 0.2rem;
      flex-wrap: nowrap;
      overflow-x: auto;
    }
    .fc .fc-button {
      padding: 0.2rem 0.3rem;
    }
  }

  /* Layout chunks so title stays inline with buttons on wide screens */
  .fc-toolbar-chunk { display: flex; align-items: center; gap: 0.5rem; }
  .fc-toolbar-chunk-left { flex: 0 0 auto; }
  .fc-toolbar-chunk-center { flex: 1 1 auto; justify-content: center; min-width: 0; }
  .fc-toolbar-chunk-right { flex: 0 0 auto; }

  .fc .fc-toolbar-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  .fc .fc-button {
    background: transparent;
    color: var(--textColor);
    border: 1px solid var(--borderColor);
    padding: 0.35rem 0.6rem;
    border-radius: 8px;
    font-weight: 600;
  }

  .fc .fc-button.fc-today-button {
    background-color: var(--primarySystem300) !important;
    color: var(--white) !important;
    border-color: var(--primarySystem300) !important;
  }
  /* Make resource column fixed and only allow time slots to scroll */
  .fc .fc-resource-area {
    position: sticky;
    left: 0;
    z-index: 30;
    background: var(--backgroundColorCard);
    border-right: 1px solid var(--borderColor);
    min-width: 140px;
  }
  

    /* Slot heights — desktop / tablet / mobile to match previous layout.
      Increase default slot height so event boxes are taller and can display
      more content (reduces clipping of multi-line event cards). */
    .fc .fc-timegrid-slot-lane { height: 2rem; }
    .fc .fc-timegrid-slot { height: 2rem; }

  @media screen and (max-width: 900px) {
    .fc .fc-timegrid-slot-lane { height: 1.4rem; }
    .fc .fc-timegrid-slot { height: 1.4rem; }
    .fc .fc-resource-area { min-width: 120px; }
  }

  @media screen and (max-width: 480px) {
    .fc .fc-timegrid-slot-lane { height: 1.1rem; }
    .fc .fc-timegrid-slot { height: 1.1rem; }
    .fc .fc-resource-area { min-width: 90px; }
  }

  .fc .fc-resource .fc-resource-main {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
  }

  .fc .fc-resource img {
    width: 36px;
    height: 36px;
    border-radius: 9999px;
    object-fit: cover;
  }

  

  /* Remove FullCalendar default yellow for the current day (dayGrid/timeGrid) */
  .fc .fc-day.fc-today,
  .fc .fc-day-top.fc-today,
  .fc .fc-day.fc-today .fc-day-number,
  .fc .fc-timegrid .fc-timegrid-slot-lane.fc-today,
  .fc .fc-timegrid .fc-slats .fc-today,
  .fc .fc-timegrid-col.fc-today,
  .fc .fc-scrollgrid-section-body td.fc-today {
    background: var(--backgroundColorCard) !important;
    background-image: none !important;
    color: var(--textColor) !important;
  }

  /* Strong now-indicator (red line) across the timegrid */
  .fc .fc-now-indicator-line,
  .fc .fc-timegrid .fc-now-indicator-line {
    background: var(--red) !important;
    height: 2px !important;
    box-shadow: 0 1px 0 rgba(255,0,0,0.15);
    z-index: 1000 !important;
  }

  /* Layout for the newly added event-row to align time/title/phone inline when there's space */
  .fc-event-row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .fc-event-time { flex: 0 0 auto; white-space: nowrap; }
  .fc-event-main { flex: 1 1 auto; min-width: 0; }
  .fc-event-phone { flex: 0 0 auto; color: var(--textLight); }

  /* Make now-indicator more visible by ensuring it's full width over slots */
  .fc .fc-timegrid .fc-now-indicator {
    pointer-events: none;
  }

  
`;

export default FullCalendarStyles;
